import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

type selectedType = 'today' | 'week' | 'month';

@Component({
  selector: 'app-select-button',
  imports: [FormsModule],
  templateUrl: './select-button.html',
  styleUrl: './select-button.scss',
})
export class SelectButton {
  @Input() selectedOption: selectedType = 'today';

  @Output() selectedOptionChange = new EventEmitter<selectedType>();

  onSelect(option: selectedType) {
    this.selectedOption = option;
    this.selectedOptionChange.emit(option);
  }
}
